import React, { Fragment, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle";
import "./App.css";
import "./Custome.css";
import Routes from "./Router";

function App() {
   return (
      <Fragment>
         <Routes />
      </Fragment>
   );
}

export default App;
